import {Component, h, Prop, Host, State} from '@stencil/core';
import {createPopper, Placement} from '@popperjs/core';

@Component({
  tag: 'ike-dropdown',
  styleUrl: 'ike-dropdown.scss',
  shadow: false,
})
export class IkeDropDown {
  @Prop() placement: string;
  @State() opened = false;
  private drop: HTMLElement;
  private trigger: HTMLElement;

  componentDidLoad() {
    const parents = [...(function*(e:any){do{yield e}while(e=e.parentNode)})(this.trigger)].reverse();
    parents[0].addEventListener('click', (event:any) => {
      if(!this.trigger.contains(event.target)){
        this.opened=false;
      }
    });
  }

  componentDidRender(){
    if(this.opened){
      createPopper(this.trigger, this.drop, {
        placement: this.placement as Placement,
        modifiers: [
          {name: 'offset', options: {offset: [0, 8]}},
        ],
      });
    }
  }

  render() {
    return <Host>
      <div class="trigger" ref={el=>this.trigger=el} onClick={()=>this.opened=!this.opened}><slot name="trigger"/></div>
      <div class={{"dropdown":true, "opened":this.opened}} role="dropdown" ref={el=>this.drop=el}>
        <slot name="content"/>
        <div id="arrow" data-popper-arrow=""/>
      </div>
    </Host>
  }
}
